import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type ViewerStore = {
    modelBrowserOpen: boolean;
    toggleModelBrowser: () => void;
    setModelBrowserOpen: (open: boolean) => void;

    propertiesPanelOpen: boolean;
    togglePropertiesPanel: () => void;
    setPropertiesPanelOpen: (open: boolean) => void;
};

const useViewerStore = create<ViewerStore>()(
    persist(
        (set) => ({
            modelBrowserOpen: false,
            toggleModelBrowser: () => set((state) => ({ modelBrowserOpen: !state.modelBrowserOpen })),
            setModelBrowserOpen: (open: boolean) => set({ modelBrowserOpen: open }),
            propertiesPanelOpen: false,
            togglePropertiesPanel: () => set((state) => ({ propertiesPanelOpen: !state.propertiesPanelOpen })),
            setPropertiesPanelOpen: (open: boolean) => set({ propertiesPanelOpen: open }),
        }),
        {
            version: 1,
            name: "viewer-storage",
            storage: createJSONStorage(() => localStorage),
        }
    )
);

export default useViewerStore;
